import { debounce } from "lodash";
import * as React from "react";
import { ComponentType } from "react";
import { connect } from "react-redux";
import { Form, actions } from "react-redux-form";
import { routerActions } from "react-router-redux";
import Alert from "react-s-alert";
import { bindActionCreators } from "redux";
import {
    GroupNoteBreadcrumbs,
    GroupsNoteBreadcrumbs,
    GroupsNoteCreateBreadcrumbs,
    InstitutionNoteBreadcrumbs,
    InstitutionNoteCreateBreadcrumbs,
    PersonnelNoteBreadcrumbs,
    PersonnelNoteCreateBreadcrumbs,
    TrialInstitutionNoteBreadcrumbs,
    TrialInstitutionNoteCreateBreadcrumbs,
    TrialNoteBreadcrumbs,
    TrialNoteCreateBreadcrumbs,
} from "src/helpers/breadcrumbHelper";
import RouterHoc, { IRouterActions, IRouterProps } from "src/hoc/RouterHoc";
import * as GroupActions from "../../../actions/groups";
import * as InstitutionActions from "../../../actions/institution";
import * as NavigationActions from "../../../actions/navigation";
import * as NoteActions from "../../../actions/note";
import * as PersonnelActions from "../../../actions/personnel";
import * as TrialActions from "../../../actions/trial";
import * as TrialInstitutionActions from "../../../actions/trialInstitution";
import { NotificationAlert } from "../../../components/common/index";
import { TextAreaFormInput } from "../../../components/form";
import {
    CheckboxFormInput,
    SelectFormInput,
    TextFormInput,
} from "../../../components/form/index";
import { RestrictedLayout } from "../../../components/layouts/index";
import { FontAwesomeIcons } from "../../../constants/fontAwesomeIcons";
import * as Dtos from "../../../dtos/Tmd.dtos";
import { RequestState } from "../../../enumerations/RequestState";
import {
    renderRegistrationFormSaveBlock,
    renderRegistrationFormSaveSuccess,
    renderRegistrationFormSaveWarning,
} from "../../../helpers/alert";
import * as AuthenticationHelper from "../../../helpers/authentication";
import {
    RegistrationComponent,
    renderFormControls,
} from "../../../helpers/formHelper";
import {
    findLookup,
    generateOptionsFromLookup,
} from "../../../helpers/lookupHelper";
import {
    GroupNoteSubMenu,
    GroupSubMenu,
    InstitutionNoteSubMenu,
    InstitutionSubMenu,
    PersonnelNoteSubMenu,
    PersonnelSubMenu,
    TrialInstitutionNoteSubMenu,
    TrialNoteSubMenu,
} from "../../../helpers/subMenuHelper";
import { RegistrationFormComponent } from "../../../interfaces/forms/IRegistrationComponent";
import { ITmdState } from "../../../reducers/index";
import { IRegistrationFormState } from "../../../reducers/reactReduxForms/index";
import {
    INoteReduxFormState,
    initialNoteState,
} from "../../../reducers/reactReduxForms/note";
import { TrialInstitutionLayout, TrialLayout } from "../../index";

import "./NotePage.scss";

interface INotePageParams {
    noteId: number;
    trialId: number;
    institutionId: number;
    trialInstitutionId: number;
    personnelId: number;
    groupId: number;
}

interface INotePageProps extends IRouterProps<INotePageParams> {
    form: Dtos.Note & IRegistrationFormState;
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    reduxFormState: INoteReduxFormState;

    noteId: number;
    trialId: number;
    institutionId: number;
    trialInstitutionId: number;
    personnelId: number;
    groupId: number;

    // From state
    institution: Dtos.Institution;
    personnel: Dtos.Personnel | undefined;
    note: Dtos.Note;
    trial: Dtos.Trial | undefined;
    trialInstitution: Dtos.TrialInstitution;
    lookups: Dtos.Lookup[];
    group: Dtos.Group;

    loadingNote: boolean;
    loadNoteSuccess: boolean;
    loadNoteFailure: boolean;

    savingNote: boolean;
    saveNoteuccess: boolean;
    saveNoteFailure: boolean;

    creatingNote: boolean;
    createNoteuccess: boolean;
    createNoteFailure: boolean;

    validatingNote: boolean;

    loadingPersonnel: boolean;
    loadPersonnelSuccess: boolean;
    loadPersonnelFailure: boolean;

    loadingTrialInstitution: boolean;
    loadTrialInstitutionSuccess: boolean;
    loadTrialInstitutionFailure: boolean;

    loadingTrial: boolean;
    loadTrialSuccess: boolean;
    loadTrialFailure: boolean;

    loadingInstitution: boolean;
    loadInstitutionSuccess: boolean;
    loadInstitutionFailure: boolean;

    loadingGroup: boolean;
    loadGroupSuccess: boolean;
    loadGroupFailure: boolean;

    validationFailures: Dtos.ResponseError[];

    user: Dtos.User;
    permissions?: Dtos.PersonnelTmdPermissions[];
}

interface INotePageActions extends IRouterActions {
    clearNote: NoteActions.INoteClearActionCreator;
    loadNote: NoteActions.INoteLoadByIdActionCreator;

    saveNote: NoteActions.INoteSaveActionCreator;
    createNote: NoteActions.INoteCreateActionCreator;
    validateNote: NoteActions.INoteValidateActionCreator;

    clearTrialInstitution: TrialInstitutionActions.ITrialInstitutionClearActionCreator;
    loadTrialInstitution: TrialInstitutionActions.ITrialInstitutionLoadByIdActionCreator;

    clearTrial: TrialActions.ITrialClearActionCreator;
    loadTrial: TrialActions.ITrialLoadByIdActionCreator;

    clearPersonnel: PersonnelActions.IPersonnelClearActionCreator;
    loadPersonnel: PersonnelActions.IPersonnelLoadByIdActionCreator;

    clearInstitution: InstitutionActions.IInstitutionClearActionCreator;
    loadInstitution: InstitutionActions.IInstitutionLoadByIdActionCreator;

    clearGroup: GroupActions.IGroupClearActionCreator;
    loadGroup: GroupActions.IGroupLoadByIdActionCreator;

    loadForm: typeof actions.load;
    changeForm: typeof actions.change;
    resetForm: typeof actions.reset;

    navigate: typeof routerActions.push;
    navigateReplace: typeof routerActions.replace;

    setBreadcrumbs: NavigationActions.ISetBreadcrumbsActionCreator;
    setDrawerItems: NavigationActions.ISetDrawerItemsActionCreator;

}

type NotePageProps = INotePageProps & INotePageActions;

const reduxFormName: string = "reduxForms.note";

class NotePage extends React.PureComponent<NotePageProps, any> {
    hasBeenSubmitted: boolean;

    constructor(props: NotePageProps) {
        super(props);

        this.state = {
            hasBeenSubmitted: false,
        };

        this.clearNote = this.clearNote.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.loadForm = this.loadForm.bind(this);
        this.debounceValidate = this.debounceValidate.bind(this);
    }

    componentDidMount() {
        const {
            loadNote,
            noteId,
            createNote,
            trialId,
            trialInstitutionId,
            institutionId,
            groupId,
            personnelId,
            loadTrial,
            loadTrialInstitution,
            setBreadcrumbs,
            setDrawerItems,
            permissions,
            location,
            loadPersonnel,
            loadInstitution,
            loadGroup
        } = this.props;
        

        if (
            trialId &&
            !trialInstitutionId &&
            !location.pathname.includes("trialinstitution")
        ) {
            if (!noteId) {
                setBreadcrumbs(TrialNoteCreateBreadcrumbs(trialId));
                setDrawerItems([]);
            } else {
                setBreadcrumbs(TrialNoteBreadcrumbs(trialId, noteId));
                setDrawerItems(TrialNoteSubMenu(trialId, noteId, permissions));
            }
        } else if (location.pathname.includes("settings")) {
            setDrawerItems([]);
            setBreadcrumbs(GroupNoteBreadcrumbs(groupId, noteId));
        } else if (personnelId && location.pathname.includes("personnel")) {
            if (!noteId) {
                setDrawerItems([]);
                setBreadcrumbs(PersonnelNoteCreateBreadcrumbs(personnelId));
            } else {
                setDrawerItems(
                    PersonnelNoteSubMenu(personnelId, noteId, permissions)
                );
                setBreadcrumbs(PersonnelNoteBreadcrumbs(personnelId, noteId));
            }
        } else if (
            institutionId &&
            location.pathname.includes("institutions")
        ) {
            if (!noteId) {
                setDrawerItems([]);
                setBreadcrumbs(InstitutionNoteCreateBreadcrumbs(institutionId));
            } else {
                setDrawerItems(
                    InstitutionNoteSubMenu(institutionId, noteId, permissions)
                );
                setBreadcrumbs(
                    InstitutionNoteBreadcrumbs(institutionId, noteId)
                );
            }
        } else if (groupId && location.pathname.includes("groups")) {
            if (!noteId) {
                setDrawerItems([]);
                setBreadcrumbs(GroupsNoteCreateBreadcrumbs(groupId));
            } else {
                setDrawerItems(GroupNoteSubMenu(groupId, noteId, permissions));
                setBreadcrumbs(GroupsNoteBreadcrumbs(groupId, noteId));
            }
        } else if (trialId && trialInstitutionId) {
            if (!noteId) {
                setDrawerItems([]);
                setBreadcrumbs(
                    TrialInstitutionNoteCreateBreadcrumbs(
                        trialId,
                        trialInstitutionId
                    )
                );
            } else {
                setDrawerItems(
                    TrialInstitutionNoteSubMenu(
                        trialId,
                        trialInstitutionId,
                        noteId,
                        permissions
                    )
                );
                setBreadcrumbs(
                    TrialInstitutionNoteBreadcrumbs(
                        trialId,
                        trialInstitutionId,
                        noteId
                    )
                );
            }
        }

        if (noteId) {
            loadNote(noteId);
        } else if (!noteId) {
            createNote(
                trialId,
                institutionId,
                trialInstitutionId,
                personnelId,
                groupId
            );
        }

        if (trialId) {
            loadTrial(trialId);
        }

        if (personnelId) {
            loadPersonnel(personnelId);
        }

        if (institutionId) {
            loadInstitution(institutionId);
        }

        if (groupId) {
            loadGroup(groupId);
        }

        if (trialInstitutionId) {
            loadTrialInstitution(trialInstitutionId);
        }
    }

    componentWillReceiveProps(_nextProps: NotePageProps) {}

    componentDidUpdate(prevProps: NotePageProps, _prevState) {
        const {
            note,
            noteId,
            form,
            navigate,
            loadNote,
            loadingNote,
            loadNoteSuccess,
            createNote,
            creatingNote,
            createNoteuccess,
            savingNote,
            saveNoteuccess,
            validationFailures,
            trialId,
            trialInstitutionId,
            institutionId,
            personnelId,
            groupId,
            loadTrial,
            loadTrialInstitution,
            trialInstitution,
            setDrawerItems,
            permissions,
            trial,
            setBreadcrumbs,
            personnel,
            location,
            institution,
            loadPersonnel,
            loadInstitution,
            group,
            loadGroup,
            loadGroupFailure,
            loadInstitutionFailure,
            loadTrialFailure,
            loadPersonnelFailure,
            loadTrialInstitutionFailure,
            loadNoteFailure,
        } = this.props;

        if (
            loadGroupFailure ||
            loadInstitutionFailure ||
            loadTrialFailure ||
            loadPersonnelFailure ||
            loadTrialInstitutionFailure ||
            loadNoteFailure
        ) {
            navigate("/error/404");
        }

        if (
            trialId &&
            !trialInstitution &&
            !location.pathname.includes("trialinstitution")
        ) {
            if (!noteId && trial?.displayName) {
                setDrawerItems([]);
                setBreadcrumbs(
                    TrialNoteCreateBreadcrumbs(trialId, trial.displayName)
                );
            } else if (noteId && trial?.displayName && note?.title) {
                setDrawerItems(TrialNoteSubMenu(trialId, noteId, permissions));
                setBreadcrumbs(
                    TrialNoteBreadcrumbs(
                        trialId,
                        noteId,
                        trial.displayName,
                        note?.title ?? "Note"
                    )
                );
            }
        } else if (location.pathname.includes("settings")) {
            setDrawerItems([]);
            setBreadcrumbs(GroupNoteBreadcrumbs(groupId, noteId));
        } else if (personnelId && location.pathname.includes("personnel")) {
            if (!noteId && personnel?.firstName && personnel?.lastName) {
                setDrawerItems([]);
                setBreadcrumbs(
                    PersonnelNoteCreateBreadcrumbs(
                        personnelId,
                        `${personnel.firstName} ${personnel.lastName}`
                    )
                );
            } else if (noteId && personnel?.firstName && personnel?.lastName) {
                setDrawerItems(
                    PersonnelNoteSubMenu(personnelId, noteId, permissions)
                );
                setBreadcrumbs(
                    PersonnelNoteBreadcrumbs(
                        personnelId,
                        noteId,
                        `${personnel.firstName} ${personnel.lastName}`,
                        note?.title ?? "Note"
                    )
                );
            }
        } else if (
            institutionId &&
            location.pathname.includes("institutions")
        ) {
            if (!noteId && institution?.name) {
                setDrawerItems([]);
                setBreadcrumbs(
                    InstitutionNoteCreateBreadcrumbs(
                        institutionId,
                        institution.name
                    )
                );
            } else if (noteId && institution?.name) {
                setDrawerItems(
                    InstitutionNoteSubMenu(institutionId, noteId, permissions)
                );
                setBreadcrumbs(
                    InstitutionNoteBreadcrumbs(
                        institutionId,
                        noteId,
                        institution.name,
                        note?.title ?? "Note"
                    )
                );
            }
        } else if (groupId && location.pathname.includes("groups")) {
            if (!noteId && group?.name) {
                setDrawerItems([]);
                setBreadcrumbs(
                    GroupsNoteCreateBreadcrumbs(groupId, group.name)
                );
            } else if (noteId && group?.name) {
                setDrawerItems(GroupNoteSubMenu(groupId, noteId, permissions));
                setBreadcrumbs(
                    GroupsNoteBreadcrumbs(
                        groupId,
                        noteId,
                        group.name,
                        note?.title ?? "Note"
                    )
                );
            }
        } else {
            if (noteId && trialInstitution) {
                setDrawerItems(
                    TrialInstitutionNoteSubMenu(
                        trialId,
                        trialInstitutionId,
                        noteId,
                        permissions
                    )
                );
                if (
                    trialId &&
                    trialInstitutionId &&
                    trial?.displayName &&
                    trialInstitution?.institution?.name &&
                    note?.title
                ) {
                    setBreadcrumbs(
                        TrialInstitutionNoteBreadcrumbs(
                            trialId,
                            trialInstitutionId,
                            noteId,
                            trial.displayName,
                            trialInstitution.institution.name,
                            note.title
                        )
                    );
                }
            } else if (
                !noteId &&
                trialId &&
                trialInstitutionId &&
                trial?.displayName &&
                trialInstitution?.institution?.name
            ) {
                setBreadcrumbs(
                    TrialInstitutionNoteCreateBreadcrumbs(
                        trialId,
                        trialInstitutionId,
                        trial.displayName,
                        trialInstitution.institution.name
                    )
                );
            }
        }

        if (form != prevProps.form) {
            this.debounceValidate();
        }

        if (noteId && prevProps.noteId != noteId) {
            loadNote(noteId);
        } else if (!noteId && prevProps.noteId) {
            createNote(
                trialId,
                institutionId,
                trialInstitutionId,
                personnelId,
                groupId
            );
        }

        if (trialId && prevProps.trialId != trialId) {
            loadTrial(trialId);
        }

        if (personnelId && prevProps.personnelId != personnelId) {
            loadPersonnel(personnelId);
        }

        if (
            trialInstitutionId &&
            prevProps.trialInstitutionId != trialInstitutionId
        ) {
            loadTrialInstitution(trialInstitutionId);
        }

        if (institutionId && prevProps.institutionId != institutionId) {
            loadInstitution(institutionId);
        }

        if (groupId && prevProps.groupId != groupId) {
            loadGroup(groupId);
        }

        if (!loadingNote && prevProps.loadingNote) {
            if (loadNoteSuccess) {
                this.loadForm();
            }
        }

        if (!savingNote && prevProps.savingNote) {
            if (saveNoteuccess) {
                if (validationFailures && validationFailures.length > 0) {
                    Alert.warning(
                        <NotificationAlert
                            alertContent={renderRegistrationFormSaveWarning(
                                validationFailures
                            )}
                            icon={FontAwesomeIcons.Solid.EXCLAMATION_CIRCLE}
                        />
                    );

                    // toggleMessageModal();
                } else {
                    Alert.success(
                        <NotificationAlert
                            alertContent={renderRegistrationFormSaveSuccess()}
                            icon={FontAwesomeIcons.Solid.CHECK}
                        />
                    );
                }
                if (form.saveAndReturn) {
                    navigate(this.baseUrl());
                } else if (!form.saveAndReturn && noteId && noteId > 0) {
                    this.loadForm();
                } else if (
                    !form.saveAndReturn &&
                    !noteId &&
                    note &&
                    note.id > 0
                ) {
                    navigate(this.baseUrl() + "/" + note.id);
                }
            } else {
                Alert.error(
                    <NotificationAlert
                        alertContent={this.renderErrorAlert()}
                        icon={FontAwesomeIcons.Solid.TIMES_OCTAGON}
                    />
                );
            }
        }

        if (!creatingNote && prevProps.creatingNote) {
            if (createNoteuccess) {
                this.loadForm();
            }
        }
    }

    componentWillUpdate(_nextProps: NotePageProps) {}

    componentWillUnmount() {
        const { resetForm, loadForm, clearTrial } = this.props;

        this.clearNote();
        clearTrial();
        loadForm(reduxFormName, initialNoteState);
        resetForm(reduxFormName);
    }

    debounceValidate = debounce(async () => {
        const hasBeenSubmitted = this.state?.hasBeenSubmitted;
        const { form, validatingNote, validateNote } = this.props;

        let changes: Dtos.Note = {} as Dtos.Note;

        if (form && hasBeenSubmitted && !validatingNote) {
            await validateNote(Object.assign({ ...form }, changes));
        }
    }, 250);

    baseUrl(): string {
        const {
            trialId,
            trialInstitutionId,
            institutionId,
            personnelId,
            groupId,
        } = this.props;

        if (personnelId && personnelId > 0) {
            return "/personnel/" + personnelId + "/notes";
        } else if (trialInstitutionId && trialInstitutionId > 0) {
            return (
                "/trials/" +
                trialId +
                "/trialinstitution/" +
                trialInstitutionId +
                "/notes"
            );
        } else if (trialId && trialId > 0) {
            return "/trials/" + trialId + "/notes";
        } else if (institutionId && institutionId > 0) {
            return "/institutions/" + institutionId + "/notes";
        } else if (groupId && groupId > 0) {
            return "/groups/" + groupId + "/notes";
        }

        return "/notes";
    }

    clearNote() {
        this.props.clearPersonnel();
        this.props.clearTrialInstitution();
        this.props.clearTrial();
        this.props.clearNote();
        this.props.clearInstitution();
        this.props.clearGroup();
    }

    showNote(): boolean {
        const { loadingNote, loadNoteSuccess } = this.props;

        if (!loadingNote && loadNoteSuccess) {
            return true;
        }

        return false;
    }

    render() {
        const {
            loadingNote,
            creatingNote,
            note,
            trialId,
            trialInstitutionId,
            institutionId,
            personnelId,
            groupId,
            permissions,
        } = this.props;

        let menu;
        let subMenu;
        let display = note ? note.parentDisplay : "";
        let subDisplay;
        if (personnelId && personnelId > 0) {
            menu = PersonnelSubMenu(personnelId, permissions);
        } else if (trialInstitutionId && trialInstitutionId > 0) {
            return (
                <TrialInstitutionLayout
                    permission={Dtos.Permission.TrialNoteView}
                    loading={loadingNote || creatingNote}
                >
                    {this.renderContent()}
                </TrialInstitutionLayout>
            );
        } else if (trialId && trialId > 0) {
            return (
                <TrialLayout
                    loadingTrial={loadingNote || creatingNote}
                    loading={loadingNote || creatingNote}
                    permission={Dtos.Permission.TrialNoteView}
                >
                    {this.renderContent()}
                </TrialLayout>
            );
        } else if (institutionId && institutionId > 0) {
            menu = InstitutionSubMenu(institutionId, permissions);
        } else if (groupId && groupId > 0) {
            return (
                <RestrictedLayout
                    permission={Dtos.Permission.GroupNotesView}
                    subMenuItems={GroupSubMenu(groupId, permissions)}
                    loading={loadingNote || creatingNote}
                >
                    {this.renderContent()}
                </RestrictedLayout>
            );
        }

        return (
            <RestrictedLayout
                subMenuTitle={display}
                subMenuItems={menu}
                sub2MenuTitle={subDisplay}
                sub2MenuItems={subMenu}
                loading={loadingNote}
            >
                {this.renderContent()}
            </RestrictedLayout>
        );
    }

    renderContent() {
        const {
            form,
            lookups,
            validationFailures,
            formProperties,
            formState,
            changeForm,
            savingNote,
            trialId,
            trialInstitutionId,
            institutionId,
            personnelId,
            groupId,
            permissions,
            trialInstitution,
        } = this.props;

        let canEdit: boolean = true;
        if (personnelId && personnelId > 0) {
            canEdit = AuthenticationHelper.hasPermission(
                permissions,
                Dtos.Permission.PersonnelNoteUpdate
            );
        } else if (trialInstitutionId && trialInstitutionId > 0) {
            canEdit =
                trialInstitution &&
                trialInstitution.trialId > 0 &&
                AuthenticationHelper.hasPermission(
                    permissions,
                    Dtos.Permission.PersonnelNoteUpdate,
                    trialInstitution.trialId,
                    trialInstitution.institutionId
                );
        } else if (trialId && trialId > 0) {
            canEdit = AuthenticationHelper.hasPermission(
                permissions,
                Dtos.Permission.TrialNoteUpdate,
                trialId,
                null
            );
        } else if (institutionId && institutionId > 0) {
            canEdit = AuthenticationHelper.hasPermission(
                permissions,
                Dtos.Permission.TrialNoteUpdate,
                null,
                institutionId
            );
        } else if (groupId && groupId > 0) {
            canEdit = AuthenticationHelper.hasPermission(
                permissions,
                Dtos.Permission.GroupNotesUpdate
            );
        }

        const formDisabled: boolean =
            !canEdit ||
            savingNote ||
            (formState && formState.formStatus == Dtos.FormStatus.Disabled);

        let formComponents: { [index: string]: RegistrationFormComponent } = {
            detailsGroup: {
                type: RegistrationComponent.RegistrationElement,
                component: (
                    <>
                        <h1>Note</h1>
                        <div className="card card-shadow" style={{ zIndex: 1 }}>
                            <div className="form-row pt-4 pb-2 px-4">
                                <div className="col-md-6">
                                    {renderFormControls(
                                        form,
                                        "note",
                                        {
                                            title: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: TextFormInput,
                                                inputDisabled: formDisabled,
                                                groupClassName:
                                                    "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName:
                                                    "col-form-label col-sm-2",
                                                fieldClassName:
                                                    "col-sm-9 generic-form-field",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                                <div className="col-md-5">
                                    {renderFormControls(
                                        form,
                                        "note",
                                        {
                                            noteTypeId: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: SelectFormInput,
                                                inputDisabled: formDisabled,
                                                inputProps: {
                                                    options:
                                                        generateOptionsFromLookup(
                                                            findLookup(
                                                                "Note",
                                                                "NoteTypeId",
                                                                lookups
                                                            ),
                                                            form.noteTypeId
                                                        ),
                                                },
                                                groupClassName:
                                                    "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName:
                                                    "col-form-label col-sm-2",
                                                fieldClassName:
                                                    "col-sm-9 generic-form-field",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                                <div className="col-md-1 d-flex align-items-center">
                                    {renderFormControls(
                                        form,
                                        "note",
                                        {
                                            active: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: CheckboxFormInput,
                                                inputDisabled: formDisabled,
                                                inputProps: {
                                                    label: "Active",
                                                },
                                                inputLabel: " ",
                                                groupClassName:
                                                    "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName:
                                                    "col-form-label col-sm-5 d-none",
                                                fieldClassName:
                                                    "col-sm-12 generic-form-field",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                            </div>
                            <div className="form-row pt-2 pb-4 px-4">
                                <div className="col-md-12">
                                    {renderFormControls(
                                        form,
                                        "note",
                                        {
                                            comments: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: TextAreaFormInput,
                                                inputDisabled: formDisabled,
                                                groupClassName:
                                                    "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName:
                                                    "col-form-label col-sm-1",
                                                fieldClassName:
                                                    "col-sm-11 generic-form-field",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                            </div>
                        </div>
                    </>
                ),
            },
        };

        return (
            <div>
                <Form
                    model={reduxFormName}
                    onSubmit={(val, _event) => this.handleOnSubmit(val)}
                    onSubmitFailed={(val) => this.handleOnSubmitFailed(val)}
                >
                    {renderFormControls(
                        form,
                        "note",
                        formComponents,
                        lookups,
                        validationFailures,
                        formProperties,
                        changeForm
                    )}
                    <div className="mt-4 mb-4 text-right">
                        <button
                            disabled={formDisabled}
                            onClick={() => {
                                this.props.changeForm(
                                    reduxFormName + ".saveAndReturn",
                                    false
                                );
                            }}
                            type="submit"
                            className="btn btn-primary mr-2"
                        >
                            Submit
                        </button>

                        <button
                            disabled={formDisabled}
                            onClick={() => {
                                this.props.changeForm(
                                    reduxFormName + ".saveAndReturn",
                                    true
                                );
                            }}
                            type="submit"
                            className="btn btn-primary mr-2"
                        >
                            Submit And Return
                        </button>
                        <button
                            onClick={this.onCancel}
                            className="btn btn-primary mr-2"
                        >
                            {" "}
                            Cancel{" "}
                        </button>
                    </div>
                </Form>
            </div>
        );
    }

    renderErrorAlert(): any {
        return (
            <div>
                The form was <strong> not </strong> saved.
            </div>
        );
    }

    renderWarningAlert(): any {
        const { validationFailures } = this.props;

        return (
            <div>
                The form was saved but was invalid with{" "}
                {validationFailures.length} errors.
            </div>
        );
    }

    renderSaveSuccessAlert(): any {
        return <div>The form has been saved successfully</div>;
    }

    handleOnSubmit(data: Dtos.Note) {
        const { hasBeenSubmitted } = this.state;
        const { saveNote } = this.props;

        if (!hasBeenSubmitted) {
            this.setState({ hasBeenSubmitted: true });
        }

        if (data) {
            let changes: Dtos.Note = {} as Dtos.Note;
            saveNote(Object.assign({ ...data }, changes));
        }
    }

    handleOnSubmitFailed(_data: Dtos.Note) {
        Alert.error(
            <NotificationAlert
                alertContent={renderRegistrationFormSaveBlock()}
                icon={FontAwesomeIcons.Solid.BAN}
            />
        );
    }

    onCancel() {
        const { navigate } = this.props;

        navigate(this.baseUrl());
    }

    loadForm() {
        const { loadForm, note } = this.props;

        let extraData: Dtos.Note = {} as Dtos.Note;

        loadForm(reduxFormName, Object.assign({ ...note }, extraData));
    }
}

const mapStateToProps = (
    state: ITmdState,
    ownProps: NotePageProps
): INotePageProps => {
    let institution: Dtos.Institution | undefined = !(
        state.institutions.formData instanceof Array
    )
        ? state.institutions.formData
        : undefined;
    let note: Dtos.Note | undefined = !(state.notes.formData instanceof Array)
        ? state.notes.formData
        : undefined;
    let trialInstitution: Dtos.TrialInstitution | undefined = !(
        state.trialInstitution.formData instanceof Array
    )
        ? state.trialInstitution.formData
        : undefined;
    let permissions = state.user.userSummary
        ? state.user.userSummary.permissions
        : [];
    let trial: Dtos.Trial | undefined = !(
        state.trials.formData instanceof Array
    )
        ? state.trials.formData
        : undefined;
    let personnel: Dtos.Personnel | undefined = !(
        state.personnel.formData instanceof Array
    )
        ? state.personnel.formData
        : undefined;
    let group: Dtos.Group | undefined = !(
        state.groups.formData instanceof Array
    )
        ? state.groups.formData
        : undefined;

    return {
        match: ownProps.match,
        noteId:
            ownProps.match &&
            ownProps.match.params.noteId &&
            ownProps.match.params.noteId.toString() != "create"
                ? ownProps.match.params.noteId
                : undefined!,
        trialId:
            ownProps.match &&
            ownProps.match.params.trialId &&
            ownProps.match.params.trialId > 0
                ? ownProps.match.params.trialId
                : undefined!,
        institutionId:
            ownProps.match &&
            ownProps.match.params.institutionId &&
            ownProps.match.params.institutionId > 0
                ? ownProps.match.params.institutionId
                : undefined!,
        trialInstitutionId:
            ownProps.match &&
            ownProps.match.params.trialInstitutionId &&
            ownProps.match.params.trialInstitutionId > 0
                ? ownProps.match.params.trialInstitutionId
                : undefined!,
        personnelId:
            ownProps.match &&
            ownProps.match.params.personnelId &&
            ownProps.match.params.personnelId > 0
                ? ownProps.match.params.personnelId
                : undefined!,
        groupId:
            ownProps.match &&
            ownProps.match.params.groupId &&
            ownProps.match.params.groupId > 0
                ? ownProps.match.params.groupId
                : undefined!,

        history: ownProps.history,
        location: ownProps.location,

        note: note!,
        trial: trial!,
        trialInstitution: trialInstitution,
        personnel: personnel!,
        institution: institution!,
        group: group!,

        loadingNote:
            state.notes.loadState &&
            state.notes.loadState.status == RequestState.Pending,
        loadNoteSuccess:
            state.notes.loadState &&
            state.notes.loadState.status == RequestState.Success,
        loadNoteFailure:
            state.notes.loadState &&
            state.notes.loadState.status == RequestState.Failure,

        savingNote:
            state.notes.saveState &&
            state.notes.saveState.status == RequestState.Pending,
        saveNoteuccess:
            state.notes.saveState &&
            state.notes.saveState.status == RequestState.Success,
        saveNoteFailure:
            state.notes.saveState &&
            state.notes.saveState.status == RequestState.Failure,

        creatingNote:
            state.notes.createState &&
            state.notes.createState.status == RequestState.Pending,
        createNoteuccess:
            state.notes.createState &&
            state.notes.createState.status == RequestState.Success,
        createNoteFailure:
            state.notes.createState &&
            state.notes.createState.status == RequestState.Failure,

        validatingNote:
            state.notes.validateState &&
            state.notes.validateState.status == RequestState.Pending,

        loadingTrial:
            state.trials.loadState &&
            state.trials.loadState.status == RequestState.Pending,
        loadTrialSuccess:
            state.trials.loadState &&
            state.trials.loadState.status == RequestState.Success,
        loadTrialFailure:
            state.trials.loadState &&
            state.trials.loadState.status == RequestState.Failure,

        loadingInstitution:
            state.institutions.loadState &&
            state.institutions.loadState.status == RequestState.Pending,
        loadInstitutionSuccess:
            state.institutions.loadState &&
            state.institutions.loadState.status == RequestState.Success,
        loadInstitutionFailure:
            state.institutions.loadState &&
            state.institutions.loadState.status == RequestState.Failure,

        loadingTrialInstitution:
            state.trialInstitution.loadState &&
            state.trialInstitution.loadState.status == RequestState.Pending,
        loadTrialInstitutionSuccess:
            state.trialInstitution.loadState &&
            state.trialInstitution.loadState.status == RequestState.Success,
        loadTrialInstitutionFailure:
            state.trialInstitution.loadState &&
            state.trialInstitution.loadState.status == RequestState.Failure,

        loadingPersonnel:
            state.personnel.loadState &&
            state.personnel.loadState.status == RequestState.Pending,
        loadPersonnelSuccess:
            state.personnel.loadState &&
            state.personnel.loadState.status == RequestState.Success,
        loadPersonnelFailure:
            state.personnel.loadState &&
            state.personnel.loadState.status == RequestState.Failure,

        loadingGroup:
            state.groups.loadState &&
            state.groups.loadState.status == RequestState.Pending,
        loadGroupSuccess:
            state.groups.loadState &&
            state.groups.loadState.status == RequestState.Success,
        loadGroupFailure:
            state.groups.loadState &&
            state.groups.loadState.status == RequestState.Failure,

        user: state.user.data,
        permissions: permissions,
        lookups: state.notes.lookups,

        form: state.reduxForms.note,
        formState: state.notes.formState,
        formProperties: state.notes.formProperties,

        reduxFormState: state.reduxForms.formState.note,
        validationFailures: note ? state.notes.validationFailures : undefined,
    };
};

const mapDispatchToProps = (
    dispatch,
    ownProps: NotePageProps
): INotePageActions => {
    return {
        navigate: ownProps.navigate,
        navigateReplace: ownProps.navigateReplace,

        loadForm: bindActionCreators(actions.load, dispatch),
        changeForm: bindActionCreators(actions.change, dispatch),
        resetForm: bindActionCreators(actions.reset, dispatch),

        loadTrialInstitution: bindActionCreators(
            TrialInstitutionActions.LoadTrialInstitutionById,
            dispatch
        ),
        clearTrialInstitution: bindActionCreators(
            TrialInstitutionActions.Clear,
            dispatch
        ),

        loadNote: bindActionCreators(NoteActions.LoadNoteById, dispatch),
        clearNote: bindActionCreators(NoteActions.Clear, dispatch),

        saveNote: bindActionCreators(NoteActions.SaveNote, dispatch),
        createNote: bindActionCreators(NoteActions.CreateNote, dispatch),
        validateNote: bindActionCreators(NoteActions.ValidateNote, dispatch),

        loadTrial: bindActionCreators(TrialActions.LoadTrialById, dispatch),
        clearTrial: bindActionCreators(TrialActions.Clear, dispatch),

        setBreadcrumbs: bindActionCreators(
            NavigationActions.SetBreadcrumbs,
            dispatch
        ),
        setDrawerItems: bindActionCreators(
            NavigationActions.SetDrawerItems,
            dispatch
        ),

        loadPersonnel: bindActionCreators(
            PersonnelActions.LoadPersonnelById,
            dispatch
        ),
        clearPersonnel: bindActionCreators(PersonnelActions.Clear, dispatch),

        loadInstitution: bindActionCreators(
            InstitutionActions.LoadInstitutionById,
            dispatch
        ),
        clearInstitution: bindActionCreators(
            InstitutionActions.Clear,
            dispatch
        ),

        loadGroup: bindActionCreators(GroupActions.LoadGroupById, dispatch),
        clearGroup: bindActionCreators(GroupActions.Clear, dispatch)
    };
};

export default RouterHoc<INotePageParams, NotePageProps>(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(NotePage) as unknown as ComponentType<NotePageProps>
) as ComponentType<any>;
